export const CATEGORIES = [
  {
    id: 'bacanie',
    name: 'Băcănie',
    subcategories: ['Orez', 'Bulgur', 'Linte', 'Făinoase', 'Paste', 'Năut', 'Specialități']
  },
  {
    id: 'muraturi',
    name: 'Murături',
    subcategories: []
  },
  {
    id: 'masline',
    name: 'Măsline',
    subcategories: []
  },
  {
    id: 'uleiuri',
    name: 'Uleiuri',
    subcategories: []
  },
  {
    id: 'condimente',
    name: 'Condimente',
    subcategories: []
  },
  {
    id: 'horeca',
    name: 'Exact pentru HoReCa',
    subcategories: []
  }
];

export const findCategoryName = (categoryId) => {
  const cat = CATEGORIES.find((c) => c.id === categoryId);
  return cat ? cat.name : categoryId;
};
